import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchDataAPI } from '../../helpers/fetchDataAPI';
import { URL_BASE_API } from '../../services/glogal';
import { store } from '../store'


export const loadReviews = createAsyncThunk(
    'reviews/loadReviews',
    async (data) => {
        const url = `${URL_BASE_API}/api/reviews/getlistreviews`;
        const token = store.getState().userLogged.token;
        const userId = store.getState().userLogged.userLogged.userId;
        const language = store.getState().configuration.language;

        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        
        const rsp = fetchDataAPI(
            url,
            {
                field01: userId, 
                field02: data.startDate, 
                field03: data.endDate,
                field04: data.albumName,
                field05: data.artistName,
                field06: data.reviewer,
                field07: data.status,
                lang: language
            },
            config
        );
        
        return rsp;
    }
);